type CatalogPageCacheEntry = {
  goods: any[];
  totalCount: number;
};

export const useCatalogViewCache = () => {
  const pageResults = useState<Record<string, CatalogPageCacheEntry>>(
    "catalog:view:page-results",
    () => ({}),
  );
  return {
    pageResults,
  };
};
